<template>
  <div class="chat-thread" ref="thread">
    <div v-for="(m, i) in messages" :key="i" class="bubble-row" :class="m.role">
      <div class="avatar">{{ m.role === 'user' ? '🧑‍⚕️' : avatar }}</div>
      <div class="bubble">
        <div class="bubble-text">{{ m.content }}</div>
        <div v-if="m.meta && m.meta.coverage != null" class="bubble-meta">
          <span class="hit" v-if="m.meta.coveredDimensions && m.meta.coveredDimensions.length">命中维度：{{ m.meta.coveredDimensions.join('、') }}</span>
          <span class="cov">覆盖 {{ m.meta.coverage }}%</span>
        </div>
      </div>
    </div>
    <div v-if="typing" class="bubble-row ai">
      <div class="avatar">{{ avatar }}</div>
      <div class="bubble typing">
        <span /><span /><span />
      </div>
    </div>
  </div>
</template>

<script>
// 多轮对话气泡流（模块②标准化病人 / ⑤问诊训练 复用）
// messages = [{role: 'user'|'ai', content, meta?}]
export default {
  name: 'ChatThread',
  props: {
    messages: { type: Array, default: () => [] },
    typing: Boolean,
    avatar: { type: String, default: '🧑' },
  },
  watch: {
    messages() { this.scrollToBottom(); },
    typing() { this.scrollToBottom(); },
  },
  methods: {
    scrollToBottom() {
      this.$nextTick(() => {
        const el = this.$refs.thread;
        if (el) el.scrollTop = el.scrollHeight;
      });
    },
  },
};
</script>

<style scoped>
.chat-thread { display: flex; flex-direction: column; gap: 14px; max-height: 460px; overflow-y: auto; padding: 4px; }
.bubble-row { display: flex; gap: 10px; }
.bubble-row.user { flex-direction: row-reverse; }
.avatar { width: 32px; height: 32px; flex: none; display: grid; place-items: center; background: var(--bg-1); border: 1px solid var(--border-1); border-radius: 50%; font-size: 15px; }
.bubble { max-width: 76%; background: var(--bg-1); border: 1px solid var(--border-1); border-radius: 12px; padding: 10px 14px; }
.bubble-row.user .bubble { background: var(--panel-1); border-color: var(--border-hi); }
.bubble-text { font-size: 13px; line-height: 1.8; white-space: pre-wrap; }
.bubble-meta { display: flex; gap: 10px; margin-top: 6px; font-size: 11px; }
.hit { color: var(--success); }
.cov { color: var(--accent); }
.bubble.typing { display: inline-flex; gap: 5px; align-items: center; padding: 14px; }
.bubble.typing span { width: 7px; height: 7px; border-radius: 50%; background: var(--text-3); animation: blink 1.2s infinite; }
.bubble.typing span:nth-child(2) { animation-delay: 0.2s; }
.bubble.typing span:nth-child(3) { animation-delay: 0.4s; }
@keyframes blink { 0%, 80%, 100% { opacity: 0.3; } 40% { opacity: 1; } }
</style>
